var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinical6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 24.4165C36 23.082 37.0793 22 38.4108 22H79.1267C80.4581 22 81.5375 23.0819 81.5375 24.4165V85.6331H36V24.4165Z",
    fill: "white",
    stroke: "#05054B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.541 40.0879V46.9908V47.977L81.444 71.7295L80.9994 63.2621L36.541 40.0879Z",
    fill: "#05054B",
    stroke: "#05054B",
    strokeWidth: 1.2716
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.541 57.0225V63.9254V64.9116L74.7752 85.099H81.444V80.6422L36.541 57.0225Z",
    fill: "#05054B",
    stroke: "#05054B",
    strokeWidth: 1.2716
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0315 23.0342L36.3711 29.9632V30.9531L81.4438 54.7953L80.9975 46.2959L37.0315 23.0342Z",
    fill: "#05054B",
    stroke: "#05054B",
    strokeWidth: 1.27641
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5774 23.1543H64.7079L81.2524 30.5736V38.0171L52.834 23.1543H54.5774Z",
    fill: "#05054B",
    stroke: "#05054B",
    strokeWidth: 1.2716
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7949 79.9374V73.6787L57.682 85.099H45.3252L36.7949 81.057V79.9374Z",
    fill: "#05054B",
    stroke: "#05054B",
    strokeWidth: 1.2716
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3418 24.4171C36.3418 23.271 37.2687 22.3418 38.4121 22.3418H79.128C80.2714 22.3418 81.1983 23.271 81.1983 24.4171V34.1018H36.3418V24.4171Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4403 44.0986H49.8787C49.1421 44.0986 48.5449 44.6972 48.5449 45.4356V72.175C48.5449 72.9134 49.1421 73.5119 49.8787 73.5119H69.4403C70.1769 73.5119 70.7741 72.9134 70.7741 72.175V45.4356C70.7741 44.6972 70.1769 44.0986 69.4403 44.0986Z",
    fill: "white",
    stroke: "#05054B",
    strokeWidth: 1.2716,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7656 50.3389H67.6598",
    stroke: "#DD1160",
    strokeWidth: 1.2716
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7656 54.7949H67.6598",
    stroke: "#DD1160",
    strokeWidth: 1.2716
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7656 59.251H67.6598",
    stroke: "#DD1160",
    strokeWidth: 1.2716
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7656 63.709H67.6598",
    stroke: "#DD1160",
    strokeWidth: 1.2716
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5381 65.9688H55.209V71.2124H55.5381V65.9688Z",
    fill: "#33333F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9067 65.9688H55.7422V71.2124H55.9067V65.9688Z",
    fill: "#33333F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4439 65.9688H56.2793V71.2124H56.4439V65.9688Z",
    fill: "#33333F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3267 65.9688H57.1621V71.2124H57.3267V65.9688Z",
    fill: "#33333F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0279 65.9688H57.8633V71.2124H58.0279V65.9688Z",
    fill: "#33333F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9131 65.9365H58.584V71.1801H58.9131V65.9365Z",
    fill: "#33333F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3033 65.9688H59.1387V71.2124H59.3033V65.9688Z",
    fill: "#33333F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3346 65.9365H59.8203V71.1801H60.3346V65.9365Z",
    fill: "#33333F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2388 65.9688H61.0742V71.2124H61.2388V65.9688Z",
    fill: "#33333F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8644 65.9688H60.5352V71.2124H60.8644V65.9688Z",
    fill: "#33333F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9381 65.9688H61.4238V71.2124H61.9381V65.9688Z",
    fill: "#33333F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8213 65.9688H62.4922V71.2124H62.8213V65.9688Z",
    fill: "#33333F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2134 65.9688H63.0488V71.2124H63.2134V65.9688Z",
    fill: "#33333F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3418 34.1016H81.1983",
    stroke: "#05054B",
    strokeWidth: 1.2716
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinical6);
export default __webpack_public_path__ + "static/media/clinical_6.4b35f14a8f1e76f12655433181f48e27.svg";
export { ForwardRef as ReactComponent };